// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"563c903a","732":"9e5af92e","977":"21e84347"}[chunkId] + ".chunk.js";
};